export const Calculator = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_109_22578)">
      <path
        d="M8.16667 9.91667H11.6667V11.0833H8.16667V9.91667ZM8.16667 7.58333V8.75H9.33333V7.58333H8.16667ZM11.6667 2.33333H4.66667V4.17608C5.08433 4.242 5.47575 4.34175 5.83333 4.47417V3.5H10.5V4.66667H6.28075C6.89033 4.963 7.37625 5.36025 7.70233 5.83333H11.6667V2.33333ZM12.25 0H4.08333C3.11675 0 2.33333 0.783417 2.33333 1.75V4.17608C2.70317 4.11775 3.09167 4.08333 3.5 4.08333V1.75C3.5 1.428 3.76133 1.16667 4.08333 1.16667H12.25C12.572 1.16667 12.8333 1.428 12.8333 1.75V12.8333H8.00625C7.84408 13.272 7.56292 13.6663 7.17967 14H14V1.75C14 0.783417 13.2166 0 12.25 0ZM11.6667 7.58333H10.5V8.75H11.6667V7.58333ZM7 7.29167V11.9583C7 13.1221 5.49558 14 3.5 14C1.50442 14 0 13.1221 0 11.9583V7.29167C0 6.12792 1.50442 5.25 3.5 5.25C5.49558 5.25 7 6.12792 7 7.29167ZM5.83333 11.9583V11.172C5.22317 11.4829 4.41292 11.6667 3.5 11.6667C2.58708 11.6667 1.77683 11.4829 1.16667 11.172V11.9583C1.16667 12.2669 2.05275 12.8333 3.5 12.8333C4.94725 12.8333 5.83333 12.2669 5.83333 11.9583ZM5.83333 9.625V8.83867C5.22317 9.14958 4.41292 9.33333 3.5 9.33333C2.58708 9.33333 1.77683 9.14958 1.16667 8.83867V9.625C1.16667 9.93358 2.05275 10.5 3.5 10.5C4.94725 10.5 5.83333 9.93358 5.83333 9.625ZM5.83333 7.29167C5.83333 6.98308 4.94725 6.41667 3.5 6.41667C2.05275 6.41667 1.16667 6.98308 1.16667 7.29167C1.16667 7.60025 2.05275 8.16667 3.5 8.16667C4.94725 8.16667 5.83333 7.60025 5.83333 7.29167Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_22578">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
